export const MainBanners = [
    { id: 'mainBanner1', url: '/assets/main/cross.jpg' },
    { id: 'mainBanner2', url: '/assets/main/quietTime.jpg' },
    { id: 'mainBanner3', url: '/assets/main/youtube.jpg' }
]